'use client'

import { CloseButton } from '@/components/ui/close-button'
import {
  Button,
  Flex,
  Input,
  VStack,
  Text,
  Box,
  SimpleGrid,
  Heading,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import { CField } from '@/_components/CField'
import LocationCyan from '@/_assets/icon-components/LocationCyan'
import { IPoint } from '@/_store/common/types'

const Mobile = ({
  city,
  address,
  formData,
  clearInput,
  saveAddress,
  handleInputChange,
}: {
  city: string
  address: string
  formData: IPoint
  clearInput: () => void
  saveAddress: () => void
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const t = useTranslations()

  return (
    <VStack
      gap={6}
      position='absolute'
      bottom={0}
      width='100%'
      left={0}
      bg='background.card'
      color={'text'}
      p={4}
      pt={0}
      justifyContent='space-between'
      zIndex={10}
      h='calc(100vh - 64px)'
    >
      <Box
        // position='absolute'
        bottom='100%'
        left={0}
        w='100%'
        bg='background.card'
      >
        <Box gap={4} mb={2}>
          <Text fontSize='xl' fontWeight={600} mb={4}>
            {t('address')}
          </Text>
          <Flex alignItems='center' gap={2}>
            <Box w='24px' h='24px'>
              <LocationCyan color='var(--primary-default)' />
            </Box>
            <Box>
              <Text
                fontWeight={600}
                lineHeight={1.2}
                fontSize={'md'}
                lineClamp={undefined}
                wordBreak='break-all'
              >
                {address}
              </Text>
              <Text mt={0.5} color='text.muted' lineHeight={1.2}>
                {city}
              </Text>
            </Box>
          </Flex>
          <Box borderTop='1px solid lightgray' my={4} />
          <Flex h='56px' position='relative' flex={1}>
            <CField label={t('title')} bgColor='background'>
              <Input
                placeholder=''
                className='peer'
                name='name'
                value={formData?.name}
                onChange={handleInputChange}
              />
            </CField>
            {formData.name && (
              <CloseButton
                aria-label='Clear input'
                size='sm'
                position='absolute'
                right='12px'
                top='50%'
                bg={'gray.300'}
                transform='translateY(-50%)'
                onClick={clearInput}
                rounded='full'
              />
            )}
          </Flex>
        </Box>

        <SimpleGrid columns={2} gap={2} my={2}>
          <CField label={t('house')} bgColor='background'>
            <Input
              placeholder=''
              maxLength={10}
              className='peer'
              name='accommodation'
              value={formData?.accommodation}
              onChange={handleInputChange}
            />
          </CField>
          <CField label={t('apartment')} bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='apartment'
              value={formData?.apartment}
              onChange={handleInputChange}
            />
          </CField>
          <CField label={t('floor')} bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='floor'
              value={formData?.floor}
              onChange={handleInputChange}
            />
          </CField>
          <CField label={t('enterance')} bgColor='background'>
            <Input
              placeholder=''
              className='peer'
              name='building'
              value={formData?.building}
              onChange={handleInputChange}
            />
          </CField>
        </SimpleGrid>
        <CField label={t('comment_to_courier')} bgColor='background'>
          <Input
            placeholder=''
            className='peer'
            name='to_address_description'
            value={formData?.to_address_description}
            onChange={handleInputChange}
          />
        </CField>
      </Box>
      <Button
        onClick={saveAddress}
        w={'100%'}
        size='xl'
        rounded={16}
        h={'56px'}
        bg='primary'
        color='primary.text'
        _hover={{
          bg: 'primary.hover',
        }}
      >
        {t('save')}
      </Button>
    </VStack>
  )
}

export default Mobile
